export default __webpack_public_path__ + "static/media/unitedkingdom.09598dce.svg";